import axiosConfig from "./axiosConfig";

interface HhDataTempFile {
  fileGuid: string;
  fileName: string;
  uploadedAt: number;
}

interface HhDataTempListResponse {
  files: HhDataTempFile[];
}

const getHhDataTemp = async (
  authToken: string
): Promise<HhDataTempListResponse> => {
  const { data } = await axiosConfig.get(`/hh_data/temp`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getHhDataTemp;
